import React, { createContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RouteConstants from "../../constants/routesContent.json";
import {
  getEmployeeList,
  createAssignRole,
  editAssignApi,
  empListRoleApi,
} from "../../api/Api";

export const RoleAssignContext = createContext({});
export const RoleAssignContextProvider = ({ children }) => {
  const location = useLocation();
  const roleAssignView = location.state;
  const navigate = useNavigate();
  const [criteria, setCriteria] = useState("Select");
  const [password, setPassword] = useState("");
  const [selectId, setSelectId] = useState(false);
  const [alert, setAlert] = useState(false);
  const [passwordVisibility, setPasswordVisibility] = useState("password");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordVisibility, setConfirmPasswordVisibility] =
    useState("password");
  const [magneticIdRequired, setMagneticIdRequired] = useState(false);
  const [role, setRole] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [empList, setEmpList] = useState([]);
  const [visibleMessage, setVisibleMessage] = useState(false);
  const [passwordMessage, setPasswordMessage] = useState(false);
  const [confirmPasswordMessage, setConfirmPasswordMessage] = useState(false);
  const [userName, setUserName] = useState("");
  const [isEditRole, setIsEditRole] = useState(false);
  const [empListCode, setEmpListCode] = useState([]);
  const [roleAssign, setRoleAssign] = useState("");
  const [assignData, setAssignData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    name: "",
    contactNumber: "",
    role: "",
    employeeId: "",
    image: "",
  });
  const [statusCode, setStatusCode] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    setRoleAssign(location?.state?.roleName);
    setIsEditRole(location?.state?.isEdit);
  }, [location?.state?.isEdit]);

  const roleManagement = () => {
    navigate(RouteConstants.SETTINGS_ROLE_MANAGEMENT);
  };
  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };
  const empListData = async (empId) => {
    try {
      const response = await empListRoleApi(empId);
      if (response?.data?.status === 200) {
        setEmpList(response?.data?.data);
        const empCodeList = response?.data?.data?.map((item) => {
          return item?.EmployeeCode;
        });
        setEmpListCode(empCodeList);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setErrorMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setShowAlert(true);

        setErrorMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);

        setErrorMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);

        setErrorMessage("Something went wrong");
      }
    }
  };

  const createRoleByAdmin = async () => {
    const roleData = {
      employeeId: assignData?.employeeId,
      role: location?.state?.roleId,
      email: assignData?.email,
      password: assignData?.password,
    };

    try {
      const response = await createAssignRole(roleData);
      if (response?.data?.status === 200) {
        setAlert(true);
        setErrorMessage(response.data.message);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setAlert(true);
        setErrorMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setAlert(true);
        console.log("error", error);
        setErrorMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setAlert(true);

        setErrorMessage(error?.response?.data?.message);
      } else {
        setAlert(true);

        setErrorMessage("Something went wrong");
      }
    }
  };

  const EditRoleByAdmin = async () => {
    const roleData = {
      password: assignData?.password,
    };
    try {
      const response = await editAssignApi(
        roleData,
        location?.state?.EmployeeDetail?.EmployeeId
      );
      if (response?.data?.status === 200) {
        setAlert(true);
        setErrorMessage(response?.data?.message);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setAlert(true);
        setErrorMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setAlert(true);
        console.log("error", error?.response?.data?.message);
        setErrorMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setAlert(true);

        setErrorMessage(error?.response?.data?.message);
      } else {
        setAlert(true);

        setErrorMessage("Something went wrong");
      }
    }
  };

  const addOrEditAssignRole = () => {
    if (assignData?.employeeId == undefined) {
      setSelectId(true);
      return;
    } else if (assignData?.password.length <= 0) {
      setPasswordMessage(true);
      setSelectId(false);
      return;
    } else if (assignData?.confirmPassword.length <= 0) {
      setConfirmPasswordMessage(true);
      setPasswordMessage(false);
      setSelectId(false);
      return;
    } else if (assignData?.password !== assignData?.confirmPassword) {
      setVisibleMessage(true);
      setPasswordMessage(false);
      setSelectId(false);
      return;
    }
    setVisibleMessage(false);
    setPasswordMessage(false);
    setSelectId(false);
    isEditRole ? EditRoleByAdmin() : createRoleByAdmin();
  };

  useEffect(() => {
    const empDetailData = empList.filter((item) => {
      return item?.EmployeeCode === criteria;
    });
    setAssignData({
      ...assignData,
      employeeId: empDetailData[0]?.EmployeeId,
      name: empDetailData[0]?.EmployeeName,
      email: empDetailData[0]?.Email,
      contactNumber: empDetailData[0]?.ContactNo
        ? empDetailData[0]?.ContactNo
        : "-",
      image: empDetailData[0]?.Image ? empDetailData[0]?.Image : "-",
    });
  }, [criteria, empList]);

  useEffect(() => {
    if (location?.state?.EmployeeDetail !== undefined) {
      const empDetailData = empList.filter((item) => {
        return item?.EmployeeId === location?.state?.EmployeeDetail?.EmployeeId;
      });
      setCriteria(location?.state?.EmployeeDetail?.EmployeeCode);
      setAssignData({
        ...assignData,
        email: location?.state?.EmployeeDetail?.Email
          ? location?.state?.EmployeeDetail?.Email
          : "-",
        employeeId: location?.state?.EmployeeDetail?.EmployeeId
          ? location?.state?.EmployeeDetail?.EmployeeId
          : "-",
        name: location?.state?.EmployeeDetail?.EmployeeName
          ? location?.state?.EmployeeDetail?.EmployeeName
          : "-",
        contactNumber: location?.state?.EmployeeDetail?.ContactNo
          ? location?.state?.EmployeeDetail?.ContactNo
          : "-",
        image: location?.state?.EmployeeDetail?.Image
          ? location?.state?.EmployeeDetail?.Image
          : "-",
      });
    }
  }, [location?.state?.EmployeeDetail, empList]);

  const providerValue = {
    criteria,
    setCriteria,
    password,
    setPassword,
    confirmPassword,
    createRoleByAdmin,
    setConfirmPassword,
    setEmpList,
    roleAssignView,
    goBack,
    magneticIdRequired,
    alert,
    roleAssign,
    setAlert,
    errorMessage,
    setMagneticIdRequired,
    addOrEditAssignRole,
    roleManagement,
    passwordMessage,
    role,
    setRole,
    EditRoleByAdmin,
    assignData,
    setAssignData,
    empList,
    confirmPasswordMessage,
    empListCode,
    userName,
    empListData,
    visibleMessage,
    setUserName,
    selectId,
    passwordVisibility,
    setPasswordVisibility,
    isEditRole,
    confirmPasswordVisibility,
    setConfirmPasswordVisibility,
    statusCode,
    logout,
  };
  return (
    <RoleAssignContext.Provider value={providerValue}>
      {children}
    </RoleAssignContext.Provider>
  );
};
